// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_rZEGmGNDI",
  aws_user_pools_web_client_id: "2700lgf72i9s87b36pee7a2cid",
  oauth: {
    domain: "us-east-1rzegmgndi.auth.us-east-1.amazoncognito.com",
    scope: [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    redirectSignIn: "https://apps.skfautoilluminate.net",
    redirectSignOut: "https://apps.skfautoilluminate.net",
    responseType: "code"
  },
  federationTarget: "COGNITO_USER_POOLS"
};


 export default awsmobile;


